module.exports = __webpack_public_path__ + "img/01.34288417.jpg";